window.addEventListener("load", function () {
  // nếu thẻ body class vn thì thêm giúp tôi 1 thể span tagage trước thẻ có class group__top bằng jquery
  if ($("body").hasClass("vn")) {
    $(".group__top").before('<span class="tagage"></span>');
  }
});
